import { PremiumBtnController } from "./premium-btn.controller";

angular
    .module("thor.shared.premium.premium-btn.component", [])
    .component("premiumBtn", {
        bindings: {
            saleWithoutShipping: "<",
            isPast: "<",
            item: "<",
            save: "&"
        },
        controller: PremiumBtnController,
        template: require("./premium-btn.html")
    });
